import { Injectable } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BehaviorSubject } from 'rxjs';
import { OrganisationUnitsPreferences } from '../model/api';

@Injectable({
    providedIn: 'root'
})
export class DateFormatService {
    private readonly DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
    private readonly DEFAULT_TIME_FORMAT = 'HH:mm';
    private readonly DEFAULT_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';

    private dateFormatSubject = new BehaviorSubject<string>(
        this.DEFAULT_DATE_FORMAT
    );
    private timeFormatSubject = new BehaviorSubject<string>(
        this.DEFAULT_TIME_FORMAT
    );
    private dateTimeFormatSubject = new BehaviorSubject<string>(
        this.DEFAULT_DATETIME_FORMAT
    );

    constructor(private bsDatepickerConfig: BsDatepickerConfig) {}

    setFormats(preferences: OrganisationUnitsPreferences | null): void {
        if (preferences) {
            this.dateFormatSubject.next(
                preferences.dateFormat || this.DEFAULT_DATE_FORMAT
            );
            this.timeFormatSubject.next(
                preferences.timeFormat || this.DEFAULT_TIME_FORMAT
            );
            this.dateTimeFormatSubject.next(
                preferences.dateTimeFormat || this.DEFAULT_DATETIME_FORMAT
            );

            this.bsDatepickerConfig.dateInputFormat =
                preferences.dateFormat || this.DEFAULT_DATE_FORMAT;
            this.bsDatepickerConfig.rangeInputFormat =
                preferences.dateFormat || this.DEFAULT_DATE_FORMAT;
        } else {
            this.resetToDefaults();
        }
    }

    getDateFormat(): string {
        return this.dateFormatSubject.value;
    }

    getTimeFormat(): string {
        return this.timeFormatSubject.value;
    }

    getDateTimeFormat(): string {
        return this.dateTimeFormatSubject.value;
    }

    resetToDefaults(): void {
        this.dateFormatSubject.next(this.DEFAULT_DATE_FORMAT);
        this.timeFormatSubject.next(this.DEFAULT_TIME_FORMAT);
        this.dateTimeFormatSubject.next(this.DEFAULT_DATETIME_FORMAT);

        this.bsDatepickerConfig.dateInputFormat = this.DEFAULT_DATE_FORMAT;
        this.bsDatepickerConfig.rangeInputFormat = this.DEFAULT_DATE_FORMAT;
    }
}
